import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0 28px 0;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0;
  }
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  .navbar {
    width: 624px;
    height: 28px;
    margin-bottom: 30px;
  }

  .info {
    width: 295px;
    height: 50px;
    margin-bottom: 40px;
  }

  .title-option {
    width: 173px;
    height: 15px;
    margin-bottom: 20px;
  }

  .option {
    width: 624px;
    height: 75px;
    margin-bottom: 20px;
  }

  .payment {
    width: 624px;
    height: 40px;
    margin-top: 10px;
  }

  @media screen and (max-width: 960px) {
    .navbar {
      width: 150px;
    }

    .option {
      width: 330px;
    }

    .payment {
      width: 319px;
    }
  }
`;

export const Container = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;

  @media screen and (max-width: 960px) {
    margin-bottom: 0px;
  }
`;

export const Back = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
  }
`;

export const Title = styled.h2`
  font-weight: 700;
  font-size: 28px;
  color: ${(props) => props.theme.colors.primaryDark2};
  display: block;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const BreadCrumb = styled.div`
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.primaryDark2};

  @media screen and (max-width: 960px) {
    display: none;
  }

  #bar {
    color: ${(props) => props.theme.colors.secundary};
  }

  #link {
    color: ${(props) => props.theme.colors.secundary};

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    font-weight: 700;
    font-size: 20px;
    color: ${(props) => props.theme.colors.primaryDark2};
    margin-bottom: 8px;
  }

  p {
    font-weight: 700;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 2px;
  }

  .space-right {
    margin-right: 4px;
  }

  .options {
    display: flex;
    color: ${(props) => props.theme.colors.gray};
    font-weight: 400;
    font-size: 12px;
    margin-bottom: 2px;
    line-height: 130%;
  }

  a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.primary};
    margin-left: 4px;
    cursor: pointer;
  }

  .date {
    font-weight: 700;
    margin-left: 4px;
  }

  @media screen and (max-width: 960px) {
    h2 {
      font-size: 20px;
    }
  }
`;

export const Subtitle = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  color: ${(props) => props.theme.colors.black};
  margin: 32px 0 20px 0;

  @media screen and (max-width: 960px) {
    margin: 28px 0 20px 0;
  }
`;

export const PortionContainer = styled.div<{
  status: String;
  canEmitBillet: boolean;
}>`
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  padding: 12px 40px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  cursor: ${(props) =>
    props.status === 'Pago' || !props.canEmitBillet ? '' : 'pointer'};

  .item {
    display: flex;
    flex-direction: column;
  }

  .status {
    display: flex;
    align-items: center;
    padding: 10px 12px 10px 12px;
    font-size: 16px;
    /* line-height:16px; */
    font-weight: 700;
    height: 35px;
    color: ${(props) => props.theme.colors.white};
    background: ${(props) =>
      props.status === 'Pago'
        ? props.theme.colors.primary
        : !props.canEmitBillet
        ? props.theme.colors.lightGray
        : props.theme.colors.primary};
    border-radius: ${(props) =>
      Number(props.theme.borderRadius)
        ? `${props.theme.borderRadius}px`
        : '5px'};
    margin-top: 16px;
  }

  .text {
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 4px;
    line-height: 18px;
  }

  .value {
    font-size: 20px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.primaryDark2};
  }

  .date {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    margin-top: 4px;

    span {
      padding-top: 3px;
    }
  }

  @media screen and (max-width: 960px) {
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    padding: 20px;

    .item {
      width: 180px;
    }

    .status {
      text-align: center;
      font-size: 14px;
      width: 80px;
      height: 43px;
    }
  }
`;
